<template>
  <BaseDialog
    :title="isShowMode ? 'Просмотр' : isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UITextField
      v-model="news.name"
      label="Название"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.news.name.$touch()"
    />

    <!--    <UITextArea-->
    <!--      v-model="news.shortText"-->
    <!--      label="Краткое описание"-->
    <!--      :disabled="isShowMode"-->
    <!--      :rows="3"-->
    <!--      :error-messages="errorMessages.shortText"-->
    <!--      @input="$v.news.shortText.$touch()"-->
    <!--    />-->

    <UITextArea
      v-model="news.fullText"
      label="Полное описание"
      :disabled="isShowMode"
      :rows="6"
      :error-messages="errorMessages.fullText"
      @input="$v.news.fullText.$touch()"
    />

    <UIFileInput
      v-if="dialog"
      v-model="news.file"
      label="Постер"
      :disabled="isShowMode"
      :loading="fileLoading"
      :error-messages="errorMessages.file"
      @input="$v.news.file.$touch()"
      @removeFile="removeFile"
    />
  </BaseDialog>
</template>

<script>
import { setValidateMessages } from '@/scripts/validation'
import { News } from '@/models'
import {
  maxLength,
  required,
} from 'vuelidate/lib/validators'
import UITextField from '@/ui/input/UITextField'
import BaseDialog from '@/ui/dialog/BaseDialog'
import UIFileInput from '@/ui/input/file/UIFileInput'
import { fileApi } from '@/api'
import UITextArea from '@/ui/input/UITextArea'

export default {
  components: {
    UITextArea,
    UIFileInput,
    UITextField,
    BaseDialog,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    news: new News(),
    fileLoading: false,
  }),

  validations() {
    return {
      news: {
        name: { required, maxLength: maxLength(200) },
        // shortText: { required, maxLength: maxLength(3000) },
        fullText: { maxLength: maxLength(6000) },
        file: {
          required,
          fileTypeJpgAndPng: (item) => Boolean(item && (item?.type === 'image/jpeg' || item?.type === 'image/png')),
        },
      },
    }
  },

  computed: {
    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.news.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.news[key])
      })

      return allErrors
    },
  },

  methods: {
    async getNewsFile() {
      if (this.news.id) {
        try {
          this.fileLoading = true

          const data = await fileApi.getFiles(this.news.id, 'news')
          if (data && data.length) {
            const body = data && data?.[0]
            body.name = body.originalName
            body.type = 'image/jpeg'
            this.news.file = body
          }
        } catch (e) {
          this.showErrorMessage(e, 'Ошибка получения новостных файлов')
        } finally {
          this.fileLoading = false
        }
      }
    },

    save() {
      this.$emit('saveNews', this.news.getForAPI(), this.news.file)
    },

    // selectFile(item) {
    //   if(item.id) this.$router.push('/file/' + item.id)
    // },

    // async downloadFile(item) {
    //   if (item.id) {
    //     const data = fileApi.getFile(item.id)
    //     download(data, item.name)
    //   }
    // },

    async removeFile() {
      try {
        if (this.news.file?.id) await fileApi.deleteFile(this.news.file.id)
        this.news.file = null
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      }
    },

    resetModal() {
      this.news = new News()
      this.$v.$reset()
    },

    closeModal() {
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.news = new News(val)
      this.getNewsFile()
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
